package org.multiplatform.kotfolio.pages.flutter

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.components.WebImage
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import org.multiplatform.kotfolio.util.Resources

@Page("/flutter/clean_architecture")
@Composable
fun CleanArchitecturePage() {
    BlogLayout(
        PageProperties(
            "Clean Architecture",
            "Introduction of MVC, MVP, MVVM and Clean architecture. Clean architecture using BLoC also uses others plugins are go router, change theme, language translation, freezed, equatable and auto mapper."
        ),
        BlogProperties("Flutter", "Clean Architecture | Solid Package Structure")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Low-Level Design (LLD)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Low-Level Design is about how the components inside your app are structured and interact with each other. It’s like the blueprint for writing actual classes, methods, interfaces, and defining responsibilities and contracts between them.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Ol {
                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "High-Level Design  (HLD): “We’ll have a Login Module, a Dashboard Module, and an API Layer.”",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Low-Level Design (LLD): “LoginViewModel will call LoginRepository → which uses RetrofitService → and handles response through Result Wrapper → updates UI via LiveData.”",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "MVC (Model View Controller)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                SpanText(
                    text = "MVC — iOS Apps default architecture is MVC. Every screen is split into three components:",
                    modifier = Modifier
                        .fontSize(FontSize.Medium)
                )

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Model — business entities and application models",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "View — show formatted data to the user",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Controller — to transform data and handle user interactions",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "MVP (Model View Presenter)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This architecture is very similar to MVC, but all the UI business logic is stored in the presenter.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "For example, we can ask the presenter to show the next view in case of handle button action. Also presenter interacts with a model to fetch and parse business entities.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In other words, the presenter contains a method called by view and makes actions on a view. In this case presenter contains reference to the view.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "MVVM (Model View ViewModel)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Another similar architecture but in this case, we could treat viewmodel as another side of a view abstraction. Viewmodel provides wrapper to model data that can be linked to view. Viewmodel contains commands (methods) to communicate with the model and the view.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Example: View could ask for service data in case of tapping button. ViewModel is responsible for fetching the data from service, parsing, processing them, and returning to the view in a proper manner.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The main difference between ViewModel and the presenter is that viewmodel doesn’t know anything about the view.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Another difference is that viewmodel could be shared with other views. Presenters do not. Presenters are associated with a concrete view.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "𝗠𝗩𝗩𝗠 separates your app into three main components — Model, View, and ViewModel.",
                            modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                        Li {
                            SpanText(
                                text = "𝗠𝗼𝗱𝗲𝗹: Represents your data and business logic. ViewModel communicates with model for local data or remote data",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li {
                            SpanText(
                                text = "𝗩𝗶𝗲𝘄: Represents the UI components. User send event to ViewModel then ViewModel gets data and send back it to update Ui to view",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li {
                            SpanText(
                                text = "𝗩𝗶𝗲𝘄𝗠𝗼𝗱𝗲𝗹: Acts as an intermediary between the Model and View, providing data to the View and handling user interactions. Controller between View and Model , which receives actions from view and request a responses from model. once model has data then return to ViewModel. Then View model send data to view. ViewModel can be used by multiple views.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }
            }

            SpanText(
                text = "Structure a large-scale",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "For a large-scale Flutter application, I would use a layered architecture with clear separation of concerns. This typically includes layers such as presentation, business logic, data, and network. I would also use dependency injection for better testability and maintainability.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Clean Architecture (CA)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "𝗖𝗹𝗲𝗮𝗻 𝗔𝗿𝗰𝗵𝗶𝘁𝗲𝗰𝘁𝘂𝗿𝗲 (CA) emphasizes the separation of concerns and the independence of different layers / components within your app.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It aims to create applications that are flexible, maintainable, and testable by enforcing a clear separation between different layers of the system.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Every architecture has one common thing — separation of concerns.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Clean Architecture (CA) is an architectural pattern that was introduced by Robert C. Martin.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It provides a way to structure applications that separate the different components of an application into modules, each with a well-defined purpose.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The main idea behind Clean Architecture (CA) is to separate the application into three main layers: the presentation layer, the domain layer, and the data layer.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The Dependency Inversion Principle (DIP) asserts that high-level modules shouldn’t depend on low-level modules but rather that both should depend on abstractions.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Flutter Clean Architecture (CA) abides by this rule. This typically entails utilizing abstract classes and interfaces in Flutter to specify the contracts across layers, facilitating easier testing and the flexibility of changing implementations.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Ul(Modifier.margin(topBottom = 0.8.em).toAttrs()) {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "𝗗𝗼𝗺𝗮𝗶𝗻 𝗟𝗮𝘆𝗲𝗿: Model / Mapper",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Application 𝗟𝗮𝘆𝗲𝗿: Usecase and business logic",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "𝗗𝗮𝘁𝗮 𝗟𝗮𝘆𝗲𝗿: Manages data and retrieve data from local and remote.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }


                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "𝗣𝗿𝗲𝘀𝗲𝗻𝘁𝗮𝘁𝗶𝗼𝗻 𝗟𝗮𝘆𝗲𝗿: Handles UI and user interactions.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Mapping",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Mapper is a straightforward class, to map data that we get from the API — in our case the DTO — to our business object.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Mapping is a technique used to convert data from one format or structure into another. This can be especially helpful when working with data from different sources or when you need to transform data to fit a specific format or model.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Mapping separates the code responsible for data transformation from other parts of your application. This makes your codebase more organized.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Mapper classes can be reused throughout your application whenever you need to perform the same data transformations.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Since mapping is a distinct part of your code, you can write unit tests specifically for your mapper classes, ensuring that your data transformations are correct.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If your data source or data model changes, you can update the mapping logic in one place (the mapper class) without affecting the rest of your codebase.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            WebImage(
                src = Resources.Images.CLEAN_ARCHITECTURE_MODEL_FLUTTER,
                modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                contentDescription = "Mapping model"
            )

            KotlinCode(
                code = """
                      //.g.dart file generate

                      flutter packages pub run build_runner build
                      flutter pub run build_runner build --delete-conflicting-outputs

                      dart run build_runner watch
                    """.trimIndent()
            )

            SpanText(
                text = "Auto mapper dart",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    import 'otp_password_mapper.auto_mappr.dart';

                    part 'otp_password_mapper.freezed.dart';
                    part 'otp_password_mapper.g.dart';

                    @Freezed(copyWith: false, equal: false)
                    class OtpPasswordMapper with _$/OtpPasswordMapper {
                      const factory OtpPasswordMapper({@JsonKey(name: JsonKeyConstant.statusCodeJsonKey)
                      final String? statusCode,

                      @JsonKey(name: JsonKeyConstant.messageJsonKey)
                      final String? message,

                      @JsonKey(name: JsonKeyConstant.otpJsonKey)
                      final String? otp}) = _OtpPasswordMapper;

                      const OtpPasswordMapper._();

                      factory OtpPasswordMapper.fromJson(Map<String, dynamic> json) =>
                          _$/OtpPasswordMapperFromJson(json);
                    }

                    @AutoMappr([MapType<OtpPasswordMapper, OtpPasswordEntity>()])
                    class OtpMapperAuto extends $/OtpMapperAuto {}

                    /*
                    extension OtpPasswordExtension on OtpPasswordMapper {
                      OtpPasswordEntity toDomain() =>
                          OtpPasswordEntity(otp: otp);
                    }*/
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    import 'package:freezed_annotation/freezed_annotation.dart';
                    part 'otp_password_entity.freezed.dart';

                    @Freezed(copyWith: false, equal: false)
                    class OtpPasswordEntity with _$/OtpPasswordEntity {
                      const factory OtpPasswordEntity({final String? otp}) = _OtpPasswordEntity;

                      const OtpPasswordEntity._();
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    OtpMapperAuto().convert(OtpPasswordMapper.fromJson(response.data))
                    """.trimIndent()
            )

            SpanText(
                text = "freezed",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    import 'package:freezed_annotation/freezed_annotation.dart';
                    part 'department_entity.freezed.dart';

                    @Freezed(copyWith: false, equal: false)
                    class DepartmentEntity with _$/DepartmentEntity {
                      const factory DepartmentEntity(
                          { final int? id,
                          final String? day}) = _DepartmentEntity;

                      const DepartmentEntity._();
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    import 'package:freezed_annotation/freezed_annotation.dart';

                    part 'department_mapper.freezed.dart';
                    part 'department_mapper.g.dart';

                    @Freezed(copyWith: false, equal: false)
                    class DepartmentMapper with _$/DepartmentMapper {
                      const factory DepartmentMapper(
                          {@JsonKey(name: 'ID') final int? id,
                          @JsonKey(name: 'DAY')
                          final String? day}) = _DepartmentMapper;

                      const DepartmentMapper._();

                      factory DepartmentMapper.fromJson(Map<String, dynamic> json) =>
                          _$/DepartmentMapperFromJson(json);
                    }

                    extension DepartmentExtension on DepartmentMapper {
                      DepartmentEntity toDomain() =>
                          DepartmentEntity(id: id, day: day);
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    response.data.map<DepartmentEntity>((data) => DepartmentMapper.fromJson(data).toDomain()).toList()
                    """.trimIndent()
            )

            SpanText(
                text = "Equatable",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    part 'department_mapper.g.dart';

                    @JsonSerializable()
                    class DepartmentMapper extends DepartmentEntity {
                      @override
                      @JsonKey(name: JsonKeyConstant.idConsignmentJsonKey)
                      final int? id;

                      @override
                      @JsonKey(name: JsonKeyConstant.dayConsignmentJsonKey)
                      final String? day;

                      const DepartmentMapper({this.id, this.day})
                          : super(id: id, day: day);

                      factory DepartmentMapper.fromJson(Map<String, dynamic> json) =>
                          _$/DepartmentMapperFromJson(json);

                      Map<String, dynamic> toJson() => _$/DepartmentMapperToJson(this);
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    import 'package:equatable/equatable.dart';

                    class DepartmentEntity extends Equatable {
                      final int? _id;
                      final String? _day;

                      const DepartmentEntity({int? id, String? day})
                          : _id = id,
                            _day = day;

                      int? get id => _id;

                      String? get day => _day;

                      @override
                      List<Object> get props => [_id!, _day!];

                      @override
                      bool get stringify => true;
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    List<DepartmentMapper>.from(response.data
                                        .map((i) => DepartmentMapper.fromJson(i)))
                    """.trimIndent()
            )

            SpanText(
                text = "Entity",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                SpanText(
                    text = "An Entity represents a core business object or concept that is central to the business logic. It is defined within the Domain Layer of the architecture.",
                    modifier = Modifier.padding(bottom = 0.3.em)
                        .fontSize(FontSize.Medium)
                )

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Domain-Centric: Entities only contain properties and methods that are directly related to the business logic. They are independent of the user interface or data sources.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )
                }

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Immutable by Design: Entities should ideally be immutable to ensure the predictability and consistency of business logic.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )
                }
            }

            KotlinCode(
                code = """
                    class Task {
                      final String id;
                      final String title;
                      final String description;
                      final bool isCompleted;

                      Task({
                        required this.id,
                        required this.title,
                        required this.description,
                        this.isCompleted = false,
                      });

                      // Business logic to mark the task as complete
                      Task complete() {
                        return Task(
                          id: id,
                          title: title,
                          description: description,
                          isCompleted: true,
                        );
                      }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Data Layer",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                SpanText(
                    text = "The data module, which is a part of the outermost layer, is responsible for handling data access and persistence. This layer manages data transactions and abstracts data sources from the rest of the application. It interacts with databases, network services, and other external interfaces. It also contains repository implementations.",
                    modifier = Modifier.padding(bottom = 0.3.em)
                        .fontSize(FontSize.Medium)
                )

                SpanText(
                    text = "The data layer provides concrete implementations, including Use Case implementations. This separation ensures we can modify how a Use Case works without touching its interface.",
                    modifier = Modifier.padding(bottom = 0.3.em)
                        .fontSize(FontSize.Medium)
                )

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Repositories (Domain): ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Actual implementations of the repositories in the Domain layer. Repositories are responsible for coordinating data from the different data sources. (Repositories provide an abstraction over the data sources and handle data retrieval and storage.)",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "DTO Models: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Representation of JSON structure that allows us to interact with our data sources. Contains the implementation of data models, which are used to represent the data entities of the application.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Data sources: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "This folder contains the implementation of data sources, which can be either remote or local. For example, an API client to communicate with a backend server can be a remote data source, while a local database can be a local data source. While local Data Source will cache or persist data.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Mapper: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Map Entity objects to Models and vice-versa. In simple terms “mapper” is often associated with the concept of mapping between different data structures or objects. A mapper is a function or a class responsible for converting an object of one type into an object of another type. This process is commonly known as mapping.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Components: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "In the data layer, you’ll typically find repositories or data access objects (DAOs) that abstract the details of data storage and retrieval. These components provide interfaces for the domain layer to interact with the underlying data without exposing implementation details.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                SpanText(
                    text = "Our data layer consists of converter, database, and repository packages. Since the data layer depends upon the domain layer, we do repository implementation here as said above. The repository communicates with the database, but for each database, we need a separate model, therefore the converter package.",
                    modifier = Modifier
                        .fontSize(FontSize.Medium)
                )
            }

            SpanText(
                text = "Domain Layer",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Column {
                    SpanText(
                        text = "The Domain layer contain pure core business rules (entity), application-specific business rules (use cases) interfaces and other abstractions.  It remains independent of the UI and any framework, allowing it to be universally applicable across different platforms.  This is where we define what our Use Cases can do, without concerning ourselves with how they do it.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "It represents the heart of the software system, where the domain-specific concepts and behaviors are implemented.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Entities (main data holders): ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "This folder contains the implementation of domain entities, which represent the real-world objects of the application. Entities should be independent of any specific implementation detail.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Repository - interface definition (communication with datasources): ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "We need interface definition for our repository and that is all we need, the rest will be done on the data layer.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Use cases - (core business logic of app): ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "This folder contains the implementation of use cases, which define the business logic of the application. Use cases depend on the domain entities and the repository interfaces.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Components: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "In the domain layer, you’ll find entities, value objects, and use cases. Entities represent the main business objects, value objects encapsulate small pieces of immutable data, and use cases represent the application’s business logic.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Dependency Direction: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "The domain layer is at the center of the architecture and should not have direct dependencies on external frameworks or technologies. Dependencies should point outward toward the interfaces defined in the data layer for data access and toward the presentation layer for user input/output.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Domain layer completely independent",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li {
                    SpanText(
                        text = "It fetches and saves the data on various data sources, it must depend upon the data layer, right? Well, we want for data layer to depend upon the domain layer, the domain layer must not have ANY dependencies.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }

                Li {
                    SpanText(
                        text = "That is why a repository interface is defined on the domain layer and its implementation is written on the data layer. That is called a Dependency Inversion Principle.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Presentation Layer",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                SpanText(
                    text = "The presentation layer is responsible for presenting information to users and capturing user input. It encompasses user interfaces, such as graphical user interfaces (GUIs), command-line interfaces (CLIs), or APIs. It is further divided into:",
                    modifier = Modifier.padding(bottom = 0.3.em)
                        .fontSize(FontSize.Medium)
                )

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Components: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Components in the presentation layer include controllers, presenters, views, or API endpoints. These components handle user input, format data for display, and communicate user actions back to the domain layer.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "pages: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "This folder contains the implementation of the pages or screens of the application.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "widgets: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "This folder contains the implementation of reusable widgets that are used across different pages or screens.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "blocs/providers: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "This folder contains the implementation of BLoCs (Business Logic Components) or providers, which are responsible for managing the state of the application. BLoCs/providers depend on the use cases and provide the necessary data to the pages or screens.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "utils: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "This folder contains helper classes or functions that are used across the presentation layer.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "In summary, Clean Architecture separates concerns into distinct layers, with the data layer handling data access and persistence, the domain layer containing the core business logic, and the presentation layer dealing with user interfaces and interactions. This separation promotes modularity, testability, and flexibility in software development.",
                modifier = Modifier
                    .fontSize(FontSize.Medium)
            )

            SpanText(
                text = "Usecase",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                SpanText(
                    text = "The second layer is responsible for fetching entities from the backend. Just fetching — not parsing! This could be known in our app as Services. We could communicate with a server using sockets, REST, or any other known way. Use cases (or services) are not affected by controllers, view models, etc. but they could be affected if some of the entities change. This scenario is known as Dependency Rule and we use a pattern called Crossing Boundaries. We could cross architecture boundaries only in a specific way. Only from the top to the bottom.",
                    modifier = Modifier.padding(bottom = 0.3.em)
                        .fontSize(FontSize.Medium)
                )

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Single Responsibility: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Each UseCase should do one thing and do it well",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Independent: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "UseCases should be independent of UI, frameworks, and external agencies",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Usecases: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Application-specific business rules. A usecase is a piece of business logic that represents a single task that the system needs to perform. The use case encapsulates the rules and logic required to perform the task, and defines the inputs and outputs required for the operation. UseCases create a clear boundary between your business logic and other layers of your application.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Entities: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Business objects of the application",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Repositories: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Abstract classes that define the expected functionality of outer layers.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Interface adapters (controllers, viewmodels, interactors, presenters): ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "This layer is application-specific. We use them to change business models to application models which will be used by our views later. For example, we could store our entities (formatted, processed) in a database.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "What is Usecase?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li {
                    SpanText(
                        text = "In Clean Architecture (CA), a use case also known as an Interactor) is a piece of business logic that represents a single task (one action) that the system needs to perform.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }

                Li {
                    SpanText(
                        text = "The use case encapsulates the rules and logic required to perform the task, and defines the inputs and outputs required for the operation.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }

                Li {
                    SpanText(
                        text = "The use case is typically implemented as a standalone module (class or function), which is responsible for coordinating the flow of data between different layers of the system, such as the domain layer and the presentation layer.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }

                Li {
                    SpanText(
                        text = "The use case is often triggered by a user action (clicking of a button) or an event (API call) in the system, and can result in changes to the state of the system or the data that is stored or retrieved.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Components of Clean Architecture",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Entities: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Entities can be represented as Dart classes that encapsulate the core data models and business logic. These should be independent of any Flutter-specific code.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                KotlinCode(
                    code = """
                        class User {
                            final String id;
                            final String name;

                            User({required this.id, required this.name});
                        }
                    """.trimIndent()
                )

                Li(Modifier.padding(bottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Usecase: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Also known as Interactors, they contain the application’s business logic. They orchestrate interactions between entities and external systems.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                KotlinCode(
                    code = """
                        class UserUseCase {
                            final UserRepository _userRepository;

                            UserUseCase(this._userRepository);  Future<User> getUserById(String userId) {
                                return _userRepository.getUserById(userId);
                            }
                        }
                    """.trimIndent()
                )

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Interfaces (Gateways): ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "Interfaces abstract away external dependencies. In Flutter, this could involve defining abstract classes or interfaces that are implemented by concrete classes responsible for interacting with databases, APIs, etc.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                KotlinCode(
                    code = """
                        abstract class UserRepository {
                            Future<User> getUserById(String userId);
                        }
                    """.trimIndent()
                )

                Li(Modifier.padding(bottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Frameworks and Drivers",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                    )

                    SpanText(
                        text = "This layer contains the UI, databases, frameworks, and other external elements. It’s responsible for implementing the interfaces defined in the inner layers.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                KotlinCode(
                    code = """
                        class UserRepositoryImpl implements UserRepository {
                            @override
                            Future<User> getUserById(String userId) {
                                // Implementation of fetching user from a data source
                            }
                        }
                    """.trimIndent()
                )
            }

            SpanText(
                text = "typedef",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                        typedef analyticsResponse = Either<RemoteFailure, String>;
                        typedef inputParam = Map<String, dynamic>?;

                        abstract class AnalyticsDataSource {
                            Future<analyticsResponse> loginAnalytics({inputParam input = const{}});
                            Future<analyticsResponse> signUpAnalytics({inputParam input = const{}});
                            Future<analyticsResponse> productEntryAnalytics({inputParam input = const{}});
                            Future<analyticsResponse> unListingAnalytics({inputParam input = const{}});
                            Future<analyticsResponse> createNewPayeeAnalytics({inputParam input = const{}});
                            Future<analyticsResponse> logoutAnalytics({inputParam input = const{}});
                        }
                    """.trimIndent()
            )

            SpanText(
                text = "Comment style",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    import 'package:freezed_annotation/freezed_annotation.dart';

                    import '../../core/const/const.dart';

                    part 'login_input.freezed.dart';
                    part 'login_input.g.dart';

                    /// [mobile] - [JsonKeyConstant.mobileJsonParamKey] Enter the mobile number
                    /// [password] - [JsonKeyConstant.passwordJsonParamKey] Enter the password
                    /// [deviceId] - [JsonKeyConstant.deviceIdJsonParamKey] Get the device id from mobile
                    /// [firebaseToken] - [JsonKeyConstant.firebaseTokenJsonParamKey] Get the firebase token from Firebase

                    @Freezed(copyWith: false, equal: false)
                    class LoginInput with _$/LoginInput {
                      @JsonSerializable(fieldRename: FieldRename.snake, explicitToJson: true)
                      factory LoginInput(
                          {@JsonKey(name: JsonKeyConstant.mobileJsonParamKey) required String mobile,
                          @JsonKey(name: JsonKeyConstant.passwordJsonParamKey) required String password,
                          @JsonKey(name: JsonKeyConstant.deviceIdJsonParamKey) String? deviceId,
                          @JsonKey(name: JsonKeyConstant.firebaseTokenJsonParamKey)
                          String? firebaseToken}) = _LoginInput;

                      factory LoginInput.fromJson(Map<String, dynamic> json) =>
                          _$/LoginInputFromJson(json);
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Localization parameter / value pass",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                       "nDaysForecast": "{days} - day forecast",
                       "@nDaysForecast": {
                         "placeholders": {
                           "days": {
                             "type": "String"
                           }
                         }
                       },

                        Text(context.l10n.nDaysForecast('0'), style: context.titleMediumStyle),
                    """.trimIndent()
            )

            SpanText(
                text = "Step clean architecture file create",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li {
                    SpanText(
                        text = "input parameter (Domain) -> equatable -> generated freezed file, serialization",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }

                Li {
                    SpanText(
                        text = "Entity create (Data - Domain) -> equatable -> generated freezed file, serialization",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }

                Li {
                    SpanText(
                        text = "Mapper create (Data)",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }

                Li {
                    SpanText(
                        text = "Repositories create (Domain)",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }
                Li {
                    SpanText(
                        text = "api name add (Core)",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }
                Li {
                    SpanText(
                        text = "RemoteDataSource abstract method create and implement",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }
                Li {
                    SpanText(
                        text = "(Domain) repositories implement (Data) repositories",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }
                Li {
                    SpanText(
                        text = "Usecase create (Domain)",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }
                Li {
                    SpanText(
                        text = "Cubit crate / GetX Controller (Controller, Binding) / Riverpod -> generated freezed class",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }
                Li {
                    SpanText(
                        text = "UI Create",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }
            }
        }
    }
}
